import React, { Fragment, useCallback, useEffect, useState } from "react";
import Dashboard from "components/Template/Dashboard";
import { listTerms } from "services/term";
import Loading from "components/Loading";
import NoData from "components/NoData";
import TermsVersion from "components/Terms/Version";
import Header from "components/Terms/Header";
import TextEditor from "components/Terms/TextEditor";

type Props = {};

const TermsConditionsIndex: React.FC<Props> = (): JSX.Element => {
  const [loading, setLoading] = useState<boolean>(false);
  const [termActive, setTermActive] = useState<any>();

  const list = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await listTerms();
      setTermActive(data);
    } catch (error) {
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    list();
  }, [list]);

  return (
    <Dashboard
      title={"Terms and Conditions"}
      breadcrumb={[]}
      subInfo={""}
      children={
        <Fragment>
          <Loading loading={loading} />
          {termActive ? (
            <>
              <Header id={termActive._id} date={termActive.updatedAt} />
              <TextEditor id={termActive._id} content={termActive.content} />
              <TermsVersion version={termActive.version} id={termActive._id} />
            </>
          ) : (
            <NoData />
          )}
        </Fragment>
      }
    />
  );
};

export default TermsConditionsIndex;
